import debounce from 'lodash/debounce';

const callbacks = [];

let eventRegistered = false;

function executeCallbacks() {
    callbacks.forEach(fn => fn());
}

export default function addCallback(cb) {
    callbacks.push(cb);

    if (!eventRegistered) {
        window.addEventListener('resize', debounce(executeCallbacks, 200));
        eventRegistered = true;
    }
}
